module.exports = {
	"header.logo.title": "GROHE - Pure Freude an Wasser",
	"footer.privacy.text": "Privacy",
	"footer.privacy.url": "https://www.grohe.es/es_es/privacidad.html",
	"footer.disclaimer.text": "Legal Info",
	"footer.disclaimer.url": "https://www.grohe.es/es_es/imprimir.html",
	"footer.copyright": "&copy; 2018 Grohe España, S.A.",
	"homepage.headline": "Configurador de GROHE SmartControl",
	"homepage.introtext": "Encuentra el sistema de ducha GROHE SmartControl que encaje mejor con tus necesidades. Tu experiencia de ducha perfecta está aquí mismo, en las puntas de tus dedos.",
	"homepage.buttonStart": "Empezar",
	"homepage.buttonStartTracking": "showersystem-configurator/start",
	"404.title": "404 Page Not Found",
	"404.link.goBack": "Go back to homepage",
	"configurator.button.seeResults": "Ver resultados",
	"question1.question": "¿Para qué zona de tu cuarto de baño necesitas una configuración de ducha?",
	"question1.option1.text": "Para mi zona de ducha",
	"question1.option2.text": "Para mi bañera, e incluirá un caño de bañera",
	"question2.question": "¿Qué tipo de instalación prefieres? ¿Vista, empotrada o una combinación de ambas?",
	"question2.option1.text": "Instalación a la vista: solución fácil y sin esfuerzos para actualización sobre la pared",
	"question2.option2.text": "Combinación: tuberías ocultas dentro de la pared y un termostato con bandeja sobre la pared",
	"question2.option3.text": "Empotrada: aspecto limpio y minimalista con toda la tecnología oculta dentro de la pared",
	"question3.question": "¿Cómo quieres que funcione tu ducha?",
	"question3.option1.text": "Funcionamiento con SmartControl y un termostato",
	"question3.option2.text": "Funcionamiento convencional y un termostato",
	"question3.option3.text": "Con un mezclador monomando",
	"question3.option4.text": "Con un sistema inversor (manteniendo la grifería actual)",
	"question4.question": "¿Qué quieres controlar con tu ducha?",
	"question4.option1.text": "Solo una teleducha",
	"question4.option2.text": "Una ducha mural grande (150-250 mm) y una teleducha",
	"question4.option3.text": "Una ducha mural extragrande (250-400 mm) y una teleducha",
	"question4.option4.text": "Una ducha mural grande (150-250 mm), una teleducha y un llenador de bañera",
	"question4.option5.text": "Una ducha mural extragrande (250-400 mm), una teleducha y un llenador de bañera",
	"question5.question": "¿Qué forma prefieres?",
	"question5.option1.text": "Cuadrada",
	"question5.option2.text": "Redonda",
	"question6.question": "¿Qué quieres controlar con tu nuevo SmartControl?",
	"question6.option1.text": "Una ducha mural con dos chorros y una teleducha",
	"question6.option2.text": "Una ducha mural con dos chorros y una teleducha",
	"question6.option3.text": "Una ducha mural, una teleducha y un llenador de bañera",
	"question6.option4.text": "Una ducha mural, dos duchas laterales y una teleducha",
	"question6.option5.text": "Una ducha mural y una teleducha",
	"question6.option6.text": "Una teleducha y un llenador de bañera",
	"question6.option7.text": "Solo una teleducha",
	"question6.option8.text": "Solo un llenador de bañera",
	"question7.question": "Elige tu color",
	"question7.option1.text": "Chrome",
	"question7.option2.text": "Blanco/Chrome",
	"question7.option3.text": "Blanco/Chrome",
	"question8.question": "¿Te gustaría incluir un termostato con un soporte de teleducha integrado?",
	"question8.option1.text": "Sí, con un soporte de teleducha integrado",
	"question8.option2.text": "No, compraré un soporte de teleducha aparte",
	"question9.question": "¿Cómo quieres que sea el soporte de la teleducha?",
	"question9.option1.text": "Una barra de ducha con soporte de ducha regulable en altura",
	"question9.option2.text": "Un soporte de ducha minimalista",
	"question10.question": "¿Quieres montar tu ducha mural en la pared o en el techo?",
	"question10.option1.text": "Ducha mural montada sobre la pared",
	"question10.option2.text": "Ducha mural montada en el techo",
	"results.title": "{productGroupsCount, plural, \none {Tu resultado} \nother {Tus resultados}\n}",
	"results.proposal.title": "Propuesta {number}",
	"results.proposal.title.single": "Propuesta",
	"results.bundle.title": "Para que la instalación sea correcta, también necesitarás:",
	"results.newConfiguration.title": "¿Quieres configurar un nuevo sistema de ducha?",
	"results.newConfiguration.buttonText": "Empezar nueva configuración",
	"results.product.number": "Número de producto: #{number}",
	"results.product.button.productInformation": "Información del producto",
	"results.product.button.dealerLocator": "Buscar una sala de exposición y venta",
	"results.product.button.buyNow": "Buy Now",
	"results.product.button.downloadPDF": "Download PDF",
	"results.product.information": "Product Information",
	"results.product.dealer": "Find a showroom",
	"hatchModal.title": "Buy online",
	"hatchModal.btnText": "Comprar en línea",
	"hatchModal.stockInfo": "{stockQuantity, plural, \nzero {Not on Stock} \nother {On Stock}\n}",
	"hatchModal.buyNow": "Buy Now"
};


//////////////////
// WEBPACK FOOTER
// ./src/translations/shower.es_es.json
// module id = 754
// module chunks = 0